The identifier for the `ApplicationLibraryQuestion`.
